const defaultLang = process.env.defaultLang || window.localStorage.getItem('_lang') || window.app.defaultLang

export const locales = {
  state: {
    i18n_loaded: false,
    i18n_lang: defaultLang,
    i18n_allowedLang: [defaultLang] // set dynamically in ./i18n.js
  },
  getters: {
    i18n_lang: state => state.i18n_lang,
    i18n_isValidLang: state => (lang) => state.i18n_allowedLang.includes(lang),
    i18n_allowedLang: state => [...new Set(state.i18n_allowedLang)]
  },
  actions: {
    i18n_addAllowedLang ({commit}, lang) {
      commit('SET_I18N_ALLOWED_LANG', lang)
    },

    i18n_setLang ({commit, state}, lang) {
      if (!state.i18n_allowedLang.includes(lang)) {
        lang = state.i18n_lang || defaultLang
      }
      if (lang === state.i18n_lang && state.i18n_loaded) {
        return
      }
      commit('SET_I18N_LANG', lang)
      commit('SET_I18N_LOADED', true)
    },

    i18n_changeLang ({commit, state}, lang) {
      const path = window.location.pathname.replace(state.i18n_lang, lang)
      console.log(window.location.replace(path))
    }
  },
  mutations: {
    SET_I18N_LANG (state, lang) {
    // state.i18n_lang = lang
    // Vue.config.lang = lang
    // window.localStorage.setItem('_lang', lang)
    },

    SET_I18N_LOADED (state, loaded) {
      state.i18n_loaded = loaded
    },

    SET_I18N_ALLOWED_LANG (state, lang) {
      state.i18n_allowedLang.push(lang)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locales/index.js